import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const printChildren = children => {
  return children
}
const Loading = props => {
  return (
    <Fragment>
      {props.ready && printChildren(props.children)}
      {!props.ready && (
        <Fragment>
          <div className='d-none'>{printChildren(props.children)}</div>
          <div className='row mx-0 align-items-center h-100'>
            <div className='mr-auto ml-auto loading-spinner '>
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  )
}

Loading.propTypes = {
  children: PropTypes.element,
  ready: PropTypes.bool
}

export default Loading



// WEBPACK FOOTER //
// ./src/features/Loading/Loading.js